import camelcaseKeys from 'camelcase-keys'
import Activity from '@src/data/activity'

type ActivityStatus = 'planned' | 'ongoing' | 'completed'

export class Meta {
  resultId: number
  resultType: string
  completedExerciseCount: number
  clubClassName?: string

  workoutName?: string

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

export class MemberActivity {

  id: number
  amount: string
  startedAt: string
  metValue: string
  status: ActivityStatus
  meta: Meta
  activity: Activity

  constructor (attributes?) {

    Object.assign(this, attributes)
    this.activity = new Activity(camelcaseKeys(this.activity))
    this.meta = this.meta ? new Meta(camelcaseKeys(this.meta)) : new Meta()

    // show ongoing activities as completed
    if (this.status === 'ongoing') {
      this.status = 'completed'
    }
  }
}
